module.exports = __webpack_public_path__ + "static/img/hhd_vip_03.068b5dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/hhd_vip_03.jpg
// module id = jMJ5
// module chunks = 1